import qs from 'querystring';

export default function HTTPService() {
  const HTTP_METHOD_GET = 'GET';
  const HTTP_METHOD_POST = 'POST';
  const HTTP_METHOD_DELETE = 'DELETE';
  const HTTP_METHOD_PUT = 'PUT';
  const HTTP_METHOD_PATCH = 'PATCH';
  const HTTP_HEADER_ACCEPT = 'Accept';
  const HTTP_HEADER_CONTENT_TYPE = 'Content-Type';

  const MIME_TYPE_JSON = 'application/json;charset=utf-8';

  return {
    get,
    getAuthenticated,
    post,
    postAuthenticated,
    postAuthenticatedWithFile,
    deleteAuthenticated,
    putAuthenticated,
    patchAuthenticated,
  };

  function get({ url, query, credentials, headers }) {
    return makeRequest({
      method: HTTP_METHOD_GET,
      url,
      query,
      headers,
    });
  }

  function putAuthenticated({ url, body, headers, query }) {
    return makeRequest({
      method: HTTP_METHOD_PUT,
      url,
      body,
      headers,
      query,
    });
  }

  function patchAuthenticated({ url, body, headers, query }) {
    return makeRequest({
      method: HTTP_METHOD_PATCH,
      url,
      body,
      headers,
      query,
    });
  }

  function getAuthenticated({ url, query, headers }) {
    return makeRequest({
      method: HTTP_METHOD_GET,
      url,
      query,
      headers,
    });
  }

  function post({ url, body, credentials }) {
    return makeRequest({ method: HTTP_METHOD_POST, url, body, credentials });
  }

  function postAuthenticated({ url, body, headers }) {
    return makeRequest({
      method: HTTP_METHOD_POST,
      url,
      body,
      headers,
    });
  }

  function postAuthenticatedWithFile({ url, body, headers }) {
    return makeRequestWithFile({
      method: HTTP_METHOD_POST,
      url,
      body,
      headers,
    });
  }

  function deleteAuthenticated({ url, body, headers, query }) {
    return makeRequest({
      method: HTTP_METHOD_DELETE,
      url,
      body,
      headers,
      query,
    });
  }

  async function makeRequest({
    method,
    url,
    query = {},
    body = {},
    headers = {},
  }) {
    const finalUrl =
      query && Object.keys(query).length
        ? `${url}?${qs.stringify(query)}`
        : url;

    const finalHeaders = Object.keys(headers).reduce((acc, headerKey) => {
      acc.append(headerKey, headers[headerKey]);
      return acc;
    }, new Headers());

    finalHeaders.set(HTTP_HEADER_ACCEPT, MIME_TYPE_JSON);

    if (method === HTTP_METHOD_POST || method === HTTP_METHOD_PUT || method === HTTP_METHOD_PATCH) {
      finalHeaders.set(HTTP_HEADER_CONTENT_TYPE, MIME_TYPE_JSON);
    }
    const requestDescription =
      method === HTTP_METHOD_POST || method === HTTP_METHOD_PUT || method === HTTP_METHOD_PATCH
        ? {
          method,
          credentials: 'include',
          headers: finalHeaders,
          body: JSON.stringify(body),
          'Access-Control-Allow-Origin': '*',
        }
        : {
          method,
          credentials: 'include',
          headers: finalHeaders,
          'Access-Control-Allow-Origin': '*',
        };

    const response = await fetch(finalUrl, requestDescription);

    let responseBody = {};
    try {
      responseBody = await response.json();
    } catch (error) { }

    if (response.ok) {
      return responseBody;
    } else {
      const responseText = await response.text();
      throw new Error(responseText);
    }
  }

  async function makeRequestWithFile({
    method,
    url,
    query = {},
    body = {},
    headers = {},
  }) {
    const finalUrl =
      query && Object.keys(query).length
        ? `${url}?${qs.stringify(query)}`
        : url;

    const finalHeaders = Object.keys(headers).reduce((acc, headerKey) => {
      acc.append(headerKey, headers[headerKey]);
      return acc;
    }, new Headers());

    finalHeaders.set(HTTP_HEADER_ACCEPT, MIME_TYPE_JSON);

    // Don't set Content-Type for FormData, let the browser set it with boundary
    const requestDescription = {
      method,
      credentials: 'include',
      headers: finalHeaders,
      body: body, // body is already FormData
      'Access-Control-Allow-Origin': '*',
    };

    const response = await fetch(finalUrl, requestDescription);

    let responseBody = {};
    try {
      responseBody = await response.json();
    } catch (error) { }

    if (response.ok) {
      return responseBody;
    } else {
      const responseText = await response.text();
      throw new Error(responseText);
    }
  }
}
